import { gsap } from "gsap";
import { useEffect } from "react";

export function useDataWIdAnimation26() {
  useEffect(() => {
    gsap.set('[data-w-id="d507ab60-f113-b22c-b32d-66ec128d2ca7"]', {"opacity": 0});
                const tl = gsap.timeline({"scrollTrigger": {"trigger": "[data-w-id=\"d507ab60-f113-b22c-b32d-66ec128d2ca7\"]", "start": "top 70%", "end": "bottom top", "toggleActions": "play none none none", "once": true}});
      tl.addLabel("label0");
      tl.to('[data-w-id="d507ab60-f113-b22c-b32d-66ec128d2ca7"]', {"duration": 0.5, "delay": 0.2, "ease": "power1.inOut", "opacity": 1}, "label0");
    return () => {
      tl.kill();
    };
  }, []);
}